<template>
  <section :class="$style.container" data-luko-tracking="AppBlock">
    <Wrapper :class="$style.inner">
      <RichText
        :text-params="content.description"
        :class="$style.description"
      />
      <div :class="$style.app_badges">
        <PLink :link-object="content.cta_app_store">
          <PImage
            :image-object="content.image_app_store"
            :class="$style.badge"
          />
        </PLink>
        <PLink :link-object="content.cta_google_play">
          <PImage
            :image-object="content.image_google_play"
            :class="$style.badge"
          />
        </PLink>
      </div>
    </Wrapper>
  </section>
</template>

<script>
import RichText from '~/components/RichText'
import PLink from '~/components/PLink'

export default {
  name: 'AppBlock',
  components: {
    RichText,
    PLink,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  computed: {
    content() {
      return this.slice.primary
    },
    items() {
      return this.slice.items
    },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  justify-content: center;
}

.inner {
  margin: 0 24px;
  padding: 24px 16px;
  border: 1px solid $gray-100;
  border-radius: 8px;

  text-align: center;

  @include above(small) {
    padding: 32px 94px;
  }
}

.description {
  @include typo-headline;
  color: $gray-700;
}

.app_badges {
  display: flex;
  justify-content: center;
  margin-top: 24px;

  column-gap: 24px;
}

.badge {
  width: 126px;
  height: 38px;

  @include above(small) {
    width: 177px;
    height: 54px;
  }
}
</style>
